/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'test': {
    width: 360.156,
    height: 200,
    viewBox: '0 0 1844 1024',
    data: '<defs/><path pid="0" d="M650.541 1022.638H108.423c-56.109 0-101.647-45.753-101.647-102.127V103.489c0-56.374 45.538-102.127 101.647-102.127h542.118c56.11 0 101.647 45.753 101.647 102.127 0 56.375-45.538 102.128-101.647 102.128h-440.47v612.766h440.47c56.11 0 101.647 45.753 101.647 102.128 0 56.374-45.538 102.127-101.647 102.127zm1084.235 0H1192.66c-56.11 0-101.647-45.753-101.647-102.127 0-56.375 45.538-102.128 101.647-102.128h440.47V205.617h-440.47c-56.11 0-101.647-45.753-101.647-102.128 0-56.374 45.538-102.127 101.647-102.127h542.117c56.11 0 101.647 45.753 101.647 102.127v817.022c0 56.374-45.537 102.127-101.647 102.127zm-406.588-408.51H515.012c-56.11 0-101.647-45.754-101.647-102.128s45.538-102.128 101.647-102.128h813.176c56.11 0 101.647 45.754 101.647 102.128s-45.538 102.128-101.647 102.128z"/>'
  }
})
